import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CarteiraAutocompleteModel } from 'src/app/carteira/carteira.model';
import { AutocompleteComponent } from '../../autocomplete/autocomplete/autocomplete.component';
import { MatAutocompleteActivatedEvent, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'carteira-autocomplete',
  templateUrl: './carteira-autocomplete.component.html',
  styleUrls: ['./carteira-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CarteiraAutocompleteComponent),
      multi: true,
    },
  ],
})
export class CarteiraAutocompleteComponent extends AutocompleteComponent<CarteiraAutocompleteModel> {

  getId(item: CarteiraAutocompleteModel) {
    return item.id + '|' + item.type;
  }

  getTitle(item: CarteiraAutocompleteModel) {
    return `${item.descricao}`;
  }

  public onOptionSelected($event: MatAutocompleteSelectedEvent): void {
    const selectedOption = this.$filteredOptions
    .getValue()
    .filter(value => value.descricao === $event.option.value)
    .pop();

    this.schema.formGroup?.get(this.schema.formControlName).setValue(this.getId(selectedOption));

    this.selectionChanged.emit(selectedOption);
  };

  public onOptionActivated($event: MatAutocompleteActivatedEvent): void {
    const selectedOption = this.$filteredOptions
    .getValue()
    .filter(value => value.descricao === $event.option.value)
    .pop();

    this.schema.formGroup?.get(this.schema.formControlName).setValue(this.getId(selectedOption));

    this.selectionChanged.emit(selectedOption);
  };
}
